export default "__VITE_ASSET__CAn2OubW__"